import { createSelector } from '@ngrx/store';
import { IRemoteXPACPortalState, ISalesState } from '../../utils/interfaces/store.interfaces';

export const selectSales = (state: IRemoteXPACPortalState) => state.sales;

export const selectSalesPermissions = createSelector(
  selectSales,
  (state: ISalesState) => state.permission
);

export const selectNews = createSelector(
  selectSales,
  (state: ISalesState) => state.news
);

export const selectPricelists = createSelector(
  selectSales,
  (state: ISalesState) => state.priceLists
);

export const selectDocuments =  createSelector(
  selectSales,
  (state: ISalesState) => state.documents
);